import useLocalization from '@app/hooks/useLocalization'
import { IOrganization } from '@app/interfaces/organization/organization'
import ThreeDots from '@app/shared/loader/ThreeDots'
import { useGetOrganizationStatusesQuery } from '@app/store/rtk/api/organization/organization-statuses-api'
import { sortByName } from '@app/utils/sort-by-name/sort-by-name'
import { Form, Select } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface props {
  organization?: IOrganization
  disabled?: boolean
}

const OrganizationStatusItem: React.FC<props> = ({
  organization,
  disabled,
}) => {
  const [t] = useTranslation()
  const { localize } = useLocalization()
  const { data, isLoading } = useGetOrganizationStatusesQuery('')

  return (
    <>
      {isLoading ? (
        <ThreeDots style="dot-pulse" height={86} padding={24} />
      ) : (
        <Form.Item
          label={t('organizationStatus.organizationStatus')}
          name={'status'}
          rules={[
            {
              required: true,
              message: t('errors.requiredMessage'),
            },
          ]}
          initialValue={
            localize(data?.response as any)?.find(
              (status) => status.id === organization?.status?.id,
            )?.id
          }
        >
          <Select disabled={disabled} allowClear={true}>
            {sortByName(localize(data?.response as any))?.map(
              (organizationStatus) => {
                if (organizationStatus.status) {
                  return (
                    <Select.Option
                      key={organizationStatus.id}
                      value={organizationStatus.id}
                    >
                      {organizationStatus.data.name}
                    </Select.Option>
                  )
                }
                return null
              },
            )}
          </Select>
        </Form.Item>
      )}
    </>
  )
}

export default OrganizationStatusItem
